import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Configuração para desenvolvimento
if (import.meta.env.DEV) {
  console.log('🚀 FalaVipPay Frontend iniciando...');
  console.log('📦 Versão:', import.meta.env.VITE_APP_VERSION || '1.0.0');
  console.log('🌐 API URL:', import.meta.env.VITE_API_URL);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);